// Internal app deployed at https://skids-mgr.pages.dev (no custom domain).
// Cloudflare Access fronts both the Pages URL and the api-worker URL when enabled.
// During phases 2-4 dev, dev-token bypass is in effect — pulled from
// localStorage["skids.devToken"] so devs can paste it once per browser.

const env = (import.meta as unknown as { env: Record<string, string> }).env;
export const API_BASE =
  env.VITE_API_BASE ?? "https://skids-api-worker-staging.satish-9f4.workers.dev";

function devHeaders(): Record<string, string> {
  if (typeof localStorage === "undefined") return {};
  const token = localStorage.getItem("skids.devToken") ?? "";
  const role = localStorage.getItem("skids.devRole") ?? "manager";
  const email =
    localStorage.getItem("skids.devEmail") ?? `${role}@skids.clinic`;
  if (!token) return {};
  return {
    "X-Dev-Token": token,
    "X-Dev-Role": role,
    "X-Dev-Email": email,
  };
}

export async function apiFetch<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...devHeaders(),
      ...(init.headers ?? {}),
    },
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`API ${res.status}: ${body}`);
  }
  return (await res.json()) as T;
}

export interface Me {
  email: string;
  role: "admin" | "manager" | "doctor" | "junior";
  groups: string[];
}
